/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Facility information for the receiver of the fax
 * @export
 * @interface LeadExchangeDestination
 */
export interface LeadExchangeDestination {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the LeadExchangeDestination interface.
 */
export function instanceOfLeadExchangeDestination(value: object): value is LeadExchangeDestination {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function LeadExchangeDestinationFromJSON(json: any): LeadExchangeDestination {
    return LeadExchangeDestinationFromJSONTyped(json, false);
}

export function LeadExchangeDestinationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadExchangeDestination {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function LeadExchangeDestinationToJSON(json: any): LeadExchangeDestination {
    return LeadExchangeDestinationToJSONTyped(json, false);
}

export function LeadExchangeDestinationToJSONTyped(value?: LeadExchangeDestination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

